import { RibbonGroupBase } from '../ribbon-interfaces';
// Find and Replace group constants
export const FIND_GROUP_ID = '_find_group';
export const FIND_ID = '_find';
export const REPLACE_ID = '_replace';
/**
 * FindGroup class for handling find and replace operations in Document Editor ribbon
 * @private
 */
export class FindGroup extends RibbonGroupBase {
    /**
     * Get the Ribbon group model for Find
     * @returns {RibbonGroupModel} - Ribbon group model for Find
     * @private
     */
    getGroupModel() {
        const id = this.ribbonId;
        return {
            id: id + FIND_GROUP_ID,
            cssClass: 'e-find-group',
            header: this.localObj.getConstant('Find'),
            enableGroupOverflow: true,
            overflowHeader: this.localObj.getConstant('Find'),
            groupIconCss: 'e-icons e-de-ctnr-find',
            collections: [
                {
                    id: id + '_find-collection',
                    items: [
                        {
                            type: 'Button',
                            keyTip: 'FD',
                            buttonSettings: {
                                content: this.localObj.getConstant('Find'),
                                iconCss: 'e-icons e-de-ctnr-find',
                                clicked: () => {
                                    if (this.documentEditor.searchModule) {
                                        this.documentEditor.optionsPaneModule.isFind = true;
                                        this.documentEditor.showOptionsPane();
                                    }
                                }
                            },
                            id: id + FIND_ID,
                            ribbonTooltipSettings: { content: this.localObj.getConstant('Find Text') }
                        },
                        {
                            type: 'Button',
                            keyTip: 'R',
                            buttonSettings: {
                                content: this.localObj.getConstant('Replace'),
                                iconCss: 'e-icons e-de-ctnr-replace',
                                clicked: () => {
                                    if (!this.documentEditor.isReadOnly && this.documentEditor.optionsPaneModule) {
                                        this.documentEditor.optionsPaneModule.isReplace = true;
                                        this.documentEditor.documentEditorSettings.showNavigationPane = true;
                                    }
                                }
                            },
                            id: id + REPLACE_ID,
                            ribbonTooltipSettings: { content: this.localObj.getConstant('Replace Text') }
                        }
                    ]
                }
            ]
        };
    }
    /**
     * Update find buttons based on document state
     * @returns {void}
     * @private
     */
    updateSelection() {
        // Get the ribbon from container
        const ribbon = this.container.ribbonModule.ribbon;
        if (!ribbon) {
            return;
        }
        const id = this.ribbonId;
        // If we need to disable replace when the document is read-only:
        if (this.documentEditor.isReadOnly) {
            ribbon.disableItem(id + REPLACE_ID);
        }
        else {
            ribbon.enableItem(id + REPLACE_ID);
        }
    }
}
